import { useEffect } from 'react'
import { useAppDispatch } from '../App.store'
import { loadQuestionnaire } from '../middleware/apollo'
import {
  checkIsFDChatResultsPage,
  checkIsResultsPage
} from '../utils/HelperFunctions'
import { useOptionalWaveId } from './useOptionalWaveId'
import { useProjectId } from './useProjectId'
import { useSurveyId } from './useSurveyId'

const usePrepareApolloMiddleware = () => {
  const surveyId = useSurveyId()
  const projectId = useProjectId()
  const waveId = useOptionalWaveId()
  const isResultsPage = checkIsResultsPage()
  const isFDChatResultsPage = checkIsFDChatResultsPage()
  const appDispatch = useAppDispatch()

  useEffect(() => {
    appDispatch(
      loadQuestionnaire(
        isResultsPage || isFDChatResultsPage
          ? null
          : { surveyId, projectId, waveId }
      )
    )
  }, [
    appDispatch,
    projectId,
    surveyId,
    waveId,
    isResultsPage,
    isFDChatResultsPage
  ])

  useEffect(() => {
    return () => {
      appDispatch(loadQuestionnaire(null))
    }
  }, [appDispatch])
}

export default usePrepareApolloMiddleware
